module.exports = __webpack_public_path__ + "img/grandparents-1-min.19be515d.jpg";